<script>
  import { Button } from "@svelteuidev/core";
  import Constantes from "../Classes/Constantes";
  import { navigate } from "svelte-routing";
  export let logo1;
  export let logo2;
  export let evento;
  export let onde;
  export let quando;
  export let descricao;
  export let atletas;
  export let data_inscricao;
  export let data_pagamento = "";
  export let qr_code;
  export let valor_pago;
  export let cod_inscricao;
  export let cod_inscricao_encurtado;
  export let status_pagamento;

  export let taxa;
  export let preco;
  export let desconto;
  export let valor_desconto;
  export let certificado;
  export let ids;
  export let inscritos;
  export let inscritos_id;

  export let taxa_pag_cartao;
  export let taxa_pag_pix;
  export let taxa_pag_boleto;


 export let taxa_pag_cartao_formatado;
  export let taxa_pag_pix_formatado;
  export let taxa_pag_boleto_formatado;
  // Função que transforma strings separadas por ';' em listas
  const transformToList = (str) => {
    return str.split(";").map((item) => item.trim());
  };
  const transformToList2 = (str) => {
    return str.split("|").map((item) => item.trim());
  };
  // Transformando ids e inscritos em listas
  $: idsList = transformToList(ids);
  $: inscritosList = transformToList(inscritos);
  $: inscritosListId = transformToList(inscritos_id);
  $: if (!data_pagamento) {
    if (status_pagamento != "Pago") {
      data_pagamento = "Aguardando pagamento";
    } else {
      data_pagamento = "";
    }
  }
  function BaixarComprovante() {
    window.location.href =
      Constantes.api_gerar_comprovante + cod_inscricao_encurtado;
  }

  function BaixarCertificado(id) {
    window.location.href =
      Constantes.api_gerar_certificado + cod_inscricao_encurtado + "&id=" + id;
  }
  function IrPagamento() {
   // navigate(Constantes.tela_pre_pagamento + "?id=" + cod_inscricao_encurtado);
     window.location.href =
      Constantes.tela_pre_pagamento + "?id=" + cod_inscricao_encurtado;
  }
</script>

<div class="row row-1">
  <div>
    <img src={logo1} alt="Imagem1" class="img" />
  </div>
  <div>
    <img src={logo2} alt="Imagem2" class="img" />
  </div>
</div>
<br /><br /><br />
<div class="row row-2">
  <div class="fonte1">
    Evento: <b>{evento}</b><br />
    Quando: <b>{quando}</b><br />
    Onde: <b>{onde}</b>
  </div>
</div>

<div class="inscricao">Comprovante</div>
<div class="row row-3">
  <div>
    <b>{@html descricao}</b><br /><br />
    Clientes(s):<br />
    <b>{@html atletas}<br /> </b><br /><br />

    {#each inscritosListId as item, i}
      {#if transformToList2(item)[2] == "1"}
        <Button fullSize on:click={BaixarCertificado(transformToList2(item)[1])}
          >Baixar Certificado de participação de {transformToList2(
            item,
          )[0]}</Button
        >
        <hr />
      {/if}
    {/each}

    {#if status_pagamento == "Pago"}
      <h5>Pagamento:</h5>
      <br />

      Valor do produto: <b>{preco}</b><br />
      <div class="vermelho">
        Desconto do cupom: <b>- {desconto}</b><br />
      </div>
      Valor após desconto do cupom:<b>{valor_desconto}</b><br />
      Taxa de inscrição Wodoxi: <b>{taxa}</b><br />
      {#if taxa_pag_cartao != 0}
        Taxa de pagamento com cartão: <b>{taxa_pag_cartao_formatado}</b><br />
      {/if}
      {#if taxa_pag_pix != 0}
        Taxa de pagamento com pix: <b>{taxa_pag_pix_formatado}</b><br />
      {/if}
      {#if taxa_pag_boleto != 0}
        Taxa de pagamento com boleto: <b>{taxa_pag_boleto_formatado}</b><br />
      {/if}

      <hr />
      <h5><b>Valor total pago: {valor_pago}</b><br /></h5>
      <hr />
    {/if}
    Data / Hora da Inscrição: <b>{data_inscricao}</b><br />
    Data / Hora do pagamento: <b>{data_pagamento}</b><br />
  </div>

  {#if status_pagamento != "Pago"}
    <h3 class="vermelho">
      Inscrição pendente de pagamento - Ainda não efetivada!
    </h3>
  {/if}
  <!--
    <div class="fonte3 rowQrcode">
      <img src="{{qr_code}}"alt="QRCode">
      <br>Dados do pagamento:<br>
      <b>{cod_inscricao}</b>
    </div>-->
</div>

<div class="row row-4 fonte2 rowQrcode">
  
  <p><br>Código de inscrição: {cod_inscricao}</p>
  {#if certificado == "1"}
    <p>Evento já realizado!</p>
  {:else}
    <p>
      Lembre-se de no dia do Evento estar de posse desse comprovante impresso ou
      no celular, além de documento de identificação.
    </p>
  {/if}

  
  {#if data_pagamento != "Aguardando pagamento"}
    <Button class="m-5" fullSize on:click={BaixarComprovante}
      >Baixar Comprovante</Button
    >
  {:else}
    <Button class="m-5" fullSize on:click={IrPagamento}
      >Ir para pagamento</Button
    >
  {/if}
  <p>
    <strong>Atenção: O Wodoxi atua apenas como um facilitador para a inscrição nos eventos esportivos. A realização, organização, e qualquer responsabilidade sobre o evento, incluindo eventuais cancelamentos ou alterações, são de inteira responsabilidade do organizador do evento, conforme cláusula 7 dos Termos de Uso. O Wodoxi não se responsabiliza por qualquer problema relacionado à execução do evento.</strong>

  </p>
</div>
<br>
<br>
<br>
<style>
  body {
    font-family: Arial, sans-serif;
  }
  .vermelho {
    color: red;
  }
  @media (max-width: 768px) {
    .row-1 {
      display: none;
    }
  }
  .row {
    display: flex;
  }

  .row-1 {
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 50px;
  }
  .rowQrcode {
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .inscricao {
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #1b4452;
    color: #ffffff;
  }
  .row-1 div {
    flex: 1;
  }
  .row-2 {
    background-color: #add8e6;
  }
  .row-3 {
    justify-content: space-between;
  }
  .row-3 div:first-child {
    flex: 4;
  }
  .row-3 div:last-child {
    flex: 1;
  }
  .row-4 {
    background-color: #add8e6;
    text-align: center;
  }
  img {
    max-width: 100px;
    height: auto;
  }
  .fonte1 {
    font-family: "Arial", sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #01023c;
  }
  .fonte2 {
    font-family: "Arial", sans-serif;
    font-size: 11px;
    line-height: 1.5;
    color: #01023c;
  }
  .fonte3 {
    font-family: "Arial", sans-serif;
    font-size: 9px;
    line-height: 1.5;
    color: #000000;
  }
</style>
